export const useDisableBodyScroll = (value: boolean): void => {
  useHead({
    bodyAttrs: {
      tagDuplicateStrategy: 'replace',
      class: { 'no-scroll': computed(() => value) },
    },
  })
}
